<!--
 * @Author: v_hllhe
 * @Date: 2022-12-23 17:29:09
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-29 18:01:12
 * @Description: 浮点数滚动效果
-->
<template>
<div id="numGif">
  <count-to
    :startVal="oldHourVal"
    :endVal="newHourVal"
    :duration="duration"
    :decimals="decimals"
  ></count-to>
  <slot></slot>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import countTo from 'vue-count-to';
export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {
    countTo,
  },
  props: {
    val: {
      type: Number,
      // default: 30.4,
    },
  },
  data() {
    // 这里存放数据
    return {
      oldHourVal: 0,
      newHourVal: 0,
      duration: 2000,
    };
  },
  // 监听属性 类似于data概念
  computed: {
    decimals() {
      const num =  String(this.val).split('.')[1];
      return num ? num.length : 0;
    },
  },
  // 监控data中的数据变化
  watch: {
    val: {
      handler(val, oldVal) {
        setTimeout(() => {
          this.newHourVal = val || 0;
        }, 500);
        this.oldHourVal = oldVal || 0;
      },
      immediate: true,
    },
  },
  // 方法集合
  methods: {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang='less' scoped>
#numGif{
  display: inline-block;
}
</style>
